import "../../../../content/projects/samolet/samolet.css";
import * as React from 'react';
export default {
  React
};